function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  background-color: transparent;\n  color: ",
        ";\n  &:hover:not(:disabled):not(:active) {\n    background-color: transparent;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import { jsx as _jsx } from "react/jsx-runtime";
import styled from "styled-components";
import Button from "../Button/Button";
import { variants } from "../Button/types";
var InactiveButton = styled(Button).withConfig({
    componentId: "sc-c692bb14-0"
})(_templateObject(), function(param) {
    var theme = param.theme, variant = param.variant;
    return variant === variants.PRIMARY ? theme.colors.primary : theme.colors.textSubtle;
});
var ButtonMenuItem = function(_param) {
    var _isActive = _param.isActive, isActive = _isActive === void 0 ? false : _isActive, _variant = _param.variant, variant = _variant === void 0 ? variants.PRIMARY : _variant, as = _param.as, props = _objectWithoutProperties(_param, [
        "isActive",
        "variant",
        "as"
    ]);
    if (!isActive) {
        return /*#__PURE__*/ _jsx(InactiveButton, _objectSpread({
            "data-active": "false",
            forwardedAs: as,
            variant: variant
        }, props));
    }
    return /*#__PURE__*/ _jsx(Button, _objectSpread({
        "data-active": "true",
        as: as,
        variant: variant
    }, props));
};
export default ButtonMenuItem;
